export const IDENTITY_TYPE_OPTIONS = [
  {
    value: "personal_id",
    description: "Personal ID (Georgian citizen/permanent resident)",
  },
  { value: "foreign_id", description: "Foreign ID (passport)" },
];

export const YES_NO_OPTIONS = [
  { value: "yes", description: "Yes" },
  { value: "no", description: "No" },
];
